import { RichTextFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';

/**
 * Helpers for things like SelectionContent, BooleanContent,...
 */
export class CrystallizeContentHelper {
  /**
   * Returns objects of stored values in [{key: 'foo', value: 'bar'}] format
   * @param content SelectionContent any used on purposes because of different APIs
   */
  static getSelectionContentValues(content: any) {
    if (!content) {
      return undefined;
    }

    return content?.options;
  }

  /**
   * Returns object of stored value in {key: 'foo', value: 'bar'} format
   * @param content SelectionContent any used on purposes because of different APIs
   */
  static getSelectionContentValue(content: any) {
    if (!content) {
      return undefined;
    }

    return content?.options?.[0];
  }

  /**
   * Returns true when a RichTextContent is missing or has no visible text.
   * @param richText RichTextFragment from a Crystallize query
   */
  static isRichTextEmpty(richText?: RichTextFragment | null): boolean {
    if (!richText) {
      return true;
    }

    const joined = richText.plainText?.join('').trim() ?? '';
    return joined.length === 0;
  }
}
